import { SideNavLinks } from '../common/SideNavLinks';

export const FallbackSideNavLinks = () => <SideNavLinks navItems={[]} />;
